import * as React from "react";
import { motion } from "framer-motion";

const container = {
	initial: {
		fill: "rgba(255, 255, 255, 0.2)",
	},
	show: {
		fill: "#00C2FF",
		transition: { duration: 1 },
	},
};

const path1 = {
	initial: {
		fill: "rgba(255, 255, 255, 0.2)",
	},
	show: {
		fill: "#00C2FF",
		transition: { duration: 1 },
	},
};
const path2 = {
	initial: {
		fill: "rgba(255, 255, 255, 0.2)",
	},
	show: {
		fill: "#ffffff",
		transition: { duration: 1 },
	},
};

function EightBrand(props) {
	return (
		<motion.svg
			variants={container}
			onHoverStart={() => props.handleHover()}
			onHoverEnd={() => props.handleHover()}
			initial="initial"
			whileHover="show"
			width={144}
			height={150}
			viewBox="0 0 144 150"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<motion.path
				variants={path1}
				d="M36.144 134.104L.29 72 36.144 9.896h71.712L143.711 72l-35.855 62.104H36.144z"
				fill="rgba(255, 255, 255, 0.2)"
				stroke="url(#prefix__paint0_linear)"
				strokeWidth={0.5}
			/>
			<motion.path
				variants={path2}
				d="M59.31 85.57c0-7.932 6.233-10.198 12.805-10.198 6.798 0 12.464 2.606 12.464 10.198 0 6.798-7.139 8.725-12.691 8.725-5.666 0-12.578-1.927-12.578-8.725zM40.387 51.576c0 8.499 3.853 14.277 12.238 16.544v.226c-5.666 1.02-15.75 3.853-15.75 17.337 0 19.15 18.016 24.929 35.013 24.929 15.977 0 35.127-6.233 35.127-24.929 0-9.745-6.799-16.43-15.524-17.337v-.226c7.478-1.7 12.351-8.385 12.351-16.544 0-11.444-10.312-21.642-31.954-21.642-13.03 0-31.5 4.306-31.5 21.642zm20.17 2.267c0-7.14 5.439-8.839 11.33-8.839 5.893 0 11.785 1.36 11.785 8.839 0 6.572-6.345 8.271-11.897 8.271-5.44 0-11.218-2.04-11.218-8.271z"
				fill="rgba(255, 255, 255, 0.2)"
			/>
			<path
				d="M52.625 68.12h.5v-.383l-.37-.1-.13.483zm0 .226l.089.492.411-.074v-.418h-.5zm38.866 0h-.5v.451l.448.047.052-.498zm0-.226l-.111-.488-.39.089v.399h.5zM59.81 85.57c0-3.811 1.484-6.197 3.71-7.655 2.263-1.482 5.35-2.043 8.594-2.043v-1c-3.329 0-6.644.571-9.14 2.206-2.533 1.658-4.165 4.371-4.165 8.492h1zm12.304-9.698c3.348 0 6.346.644 8.493 2.16 2.118 1.496 3.47 3.884 3.47 7.538h1c0-3.939-1.48-6.65-3.893-8.355-2.386-1.684-5.62-2.343-9.07-2.343v1zm11.964 9.698c0 3.18-1.65 5.209-4 6.471-2.378 1.278-5.459 1.754-8.191 1.754v1c2.82 0 6.085-.487 8.664-1.873 2.607-1.4 4.527-3.733 4.527-7.352h-1zm-12.191 8.225c-2.79 0-5.84-.477-8.174-1.752-2.303-1.259-3.904-3.286-3.904-6.473h-1c0 3.612 1.856 5.947 4.425 7.35 2.539 1.388 5.778 1.875 8.653 1.875v-1zm-32-42.219c0 4.324.98 8.004 3.068 10.901 2.091 2.902 5.258 4.969 9.538 6.125l.261-.965c-4.104-1.11-7.056-3.065-8.988-5.744-1.934-2.684-2.88-6.142-2.88-10.317h-1zM52.124 68.12v.226h1v-.226h-1zm.411-.266c-2.85.514-6.89 1.493-10.218 4.093-3.357 2.62-5.943 6.848-5.943 13.736h1c0-6.596 2.456-10.527 5.558-12.948 3.13-2.444 6.966-3.39 9.78-3.897l-.177-.984zM36.375 85.683c0 9.769 4.613 16.158 11.382 20.078 6.736 3.901 15.59 5.351 24.13 5.351v-1c-8.455 0-17.108-1.44-23.629-5.216-6.488-3.757-10.883-9.832-10.883-19.213h-1zm35.513 25.429c8.04 0 16.918-1.567 23.803-5.52 6.911-3.968 11.824-10.35 11.824-19.909h-1c0 9.138-4.663 15.219-11.321 19.042-6.684 3.837-15.37 5.387-23.306 5.387v1zm35.627-25.429c0-10.014-7.006-16.902-15.972-17.834l-.104.995c8.484.881 15.076 7.364 15.076 16.839h1zM91.991 68.346v-.226h-1v.226h1zm-.39.261c7.736-1.758 12.741-8.67 12.741-17.03h-1c0 7.955-4.74 14.414-11.962 16.055l.222.975zm12.741-17.03c0-5.886-2.657-11.442-8.06-15.513-5.395-4.064-13.5-6.63-24.394-6.63v1c10.748 0 18.62 2.533 23.792 6.429 5.162 3.889 7.662 9.154 7.662 14.713h1zM71.888 29.433c-6.556 0-14.521 1.08-20.867 4.376-6.375 3.31-11.134 8.873-11.134 17.766h1c0-8.443 4.476-13.702 10.594-16.879 6.147-3.191 13.932-4.263 20.407-4.263v-1zM61.057 53.843c0-3.42 1.288-5.458 3.222-6.673 1.976-1.242 4.693-1.666 7.609-1.666v-1c-2.976 0-5.925.426-8.141 1.819-2.26 1.42-3.69 3.8-3.69 7.52h1zm10.83-8.339c2.929 0 5.763.342 7.853 1.548 1.035.597 1.886 1.405 2.48 2.494.597 1.092.952 2.493.952 4.297h1c0-1.936-.381-3.51-1.074-4.776-.693-1.27-1.684-2.204-2.858-2.881-2.33-1.344-5.387-1.682-8.352-1.682v1zm11.285 8.339c0 3.083-1.468 4.992-3.606 6.161-2.174 1.189-5.051 1.61-7.791 1.61v1c2.812 0 5.884-.428 8.27-1.732 2.423-1.325 4.127-3.55 4.127-7.04h-1zm-11.397 7.771c-2.67 0-5.373-.502-7.39-1.726-1.987-1.206-3.328-3.118-3.328-6.045h-1c0 3.304 1.548 5.528 3.81 6.9 2.232 1.354 5.139 1.871 7.908 1.871v-1z"
				fill="url(#prefix__paint1_linear)"
			/>
			<defs>
				<linearGradient
					id="prefix__paint0_linear"
					x1={72}
					y1={10}
					x2={72}
					y2={161.5}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#fff" />
					<stop offset={1} stopColor="#fff" stopOpacity={0} />
				</linearGradient>
				<linearGradient
					id="prefix__paint1_linear"
					x1={71.999}
					y1={17.705}
					x2={71.999}
					y2={149.902}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#fff" />
					<stop offset={0.828} stopColor="#fff" stopOpacity={0} />
				</linearGradient>
			</defs>
		</motion.svg>
	);
}

export default EightBrand;
